<template>
  <div class="mt-5" v-if="activeProducts || inactiveProducts">
    <h2>Opplevelser</h2>
    <p>Her finner du dine aktive og inaktive opplevelser, samt bookingopplysninger.</p>
    <div class="section" v-if="activeProducts">
      <h4>Aktive produkter</h4>
      <b-table fixed :items="Object.entries(activeProducts)" :fields="fields">
        <template slot="name" slot-scope="data">
          <a
            target="_blank"
            :href="`${urlPrefix}opplevelser/${data.item[1][0].product_info.product.slug}`"
            >{{ data.item[0] }}</a
          >
        </template>
        <template slot="show_details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails" class="mr-2" variant="outline-secondary">
            {{ row.detailsShowing ? 'Skjul' : 'Vise' }} bookingopplysninger
          </b-button>
        </template>
        <template slot="row-details" slot-scope="data">
          <b-tabs content-class="mt-3">
            <b-tab
              v-for="(pis, i) in data.item[1]"
              :key="pis.id"
              :title="pis.place.name"
              :active="i === 0"
            >
              <table class="table">
                <tbody>
                  <tr v-if="pis.product_info.price">
                    <th>Pris</th>
                    <td>{{ parseInt(pis.product_info.price).toFixed(2) }} kr</td>
                  </tr>
                  <tr v-if="pis.phone">
                    <th>Telefonnummer</th>
                    <td>{{ pis.phone }}</td>
                  </tr>
                  <tr v-if="pis.phone_hours">
                    <th>Telefontid</th>
                    <td>{{ pis.phone_hours }}</td>
                  </tr>
                  <tr v-if="pis.url">
                    <th>Hjemmeside</th>
                    <td>{{ pis.url }}</td>
                  </tr>
                  <tr v-if="pis.external_bookingform">
                    <th>Ekstern booking</th>
                    <td>{{ pis.external_bookingform }}</td>
                  </tr>
                  <tr v-if="pis.email">
                    <th>E-postadresse</th>
                    <td>{{ pis.email }}</td>
                  </tr>
                  <tr v-if="pis.address">
                    <th>Adresse</th>
                    <td>{{ pis.address }}</td>
                  </tr>
                  <tr v-if="pis.info">
                    <th>Øvrig info</th>
                    <td>{{ pis.info }}</td>
                  </tr>
                </tbody>
              </table>
            </b-tab>
          </b-tabs>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    this.getProducts();
  },
  data() {
    return {
      urlPrefix: process.env.VUE_APP_URL,
      fields: [
        {
          key: 'name',
          label: 'Navn',
        },
        {
          key: 'show_details',
          label: 'Bookingopplysninger',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      activeProducts: 'products/activeProducts',
      inactiveProducts: 'products/inactiveProducts',
    }),
  },
  methods: {
    ...mapActions({
      getProducts: 'products/getProducts',
    }),
  },
};
</script>

<style scoped>
th {
  width: 50%;
}
</style>
